import { Store } from 'pullstate';
import ls from 'local-storage';

export const UserStore = new Store({
  authenticated: !!ls('boxpressd_admin_token_id'),
  user: ls('user'), // INFO This is the same as auth.user
  firebaseUser: null,
});
